import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { identity } from '@fullcalendar/core/internal';
import { AppService } from 'src/app/services/app/app.service';
class FormElement {
  constructor(public name: string, public img: string, public  type: string, public selected: boolean) { }
}
@Component({
  selector: 'app-add-form-fields',
  templateUrl: './add-form-fields.component.html',
  styleUrls: ['./add-form-fields.component.scss']
})
export class AddFormFieldsComponent {
  public formElementArr: FormElement[] = [
    { name: "Description", img: "assets/images/forms/description_ic.svg", type: "description", selected: true },
    { name: "Dropdown", img: "assets/images/forms/dropdown_ic.svg",  type: "dropdown", selected: false },
    { name: "Open Ended", img: "assets/images/forms/open_ended_ic.svg",  type: "open_ended", selected: false },
    { name: "Rating", img: "assets/images/forms/rating_ic.svg",  type: "rating", selected: false },
    { name: "Opinion Scale", img: "assets/images/forms/opinion_scale.svg",  type: "opinion_scale", selected: false },
    { name: "Numeric Range", img: "assets/images/forms/numeric_range.svg",  type: "numeric_range", selected: false },
    { name: "Yes/No", img: "assets/images/forms/yes_no.svg",  type: "yes_no", selected: false },
  ];
  public starCount: number = 5;
  public selectedElement: any = {
    su_q: "",         //question 
    desc: "",      //question description
    i_r: "",       //Required
    i_m:"",        //is multiple selection
    q_dt: "",         // q_dtwer could be array also range also and blank also
    rt: this.starCount,  //rating stars
    title: "",
    isOptionErr: false,          
    s_di:"",
    min:"",
    max:""
  };

  public selectOptionArr: any[] = [
    { val: "" }
  ]
  public fieldForm!: FormGroup;
  public isError: boolean = false;
  public errorMsg!:String;
  constructor(public dialogRef: MatDialogRef<AddFormFieldsComponent>, private fb: FormBuilder, private appService: AppService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any) { }
  ngOnInit(): void {
    this.selectedElement.type = "description"
    this.selectedElement.title = 'Description'

    this.fieldForm = this.fb.group({
      'su_q': [this.selectedElement.que, Validators.required],
      'desc': [this.selectedElement.desc, '']
    })
    if(this.dialogData){
      this.selectedElement=this.dialogData;
      this.formElementArr.map(i => i.selected = i.type == this.selectedElement.type ? true : false);
      if(this.selectedElement.type=='rating'){
        this.starCount=this.selectedElement["rt"]
        this.starCount=this.dialogData["q_dt"]
      }
      if(this.selectedElement.type=="dropdown"){
        this.selectOptionArr=[]
        this.selectOptionArr=this.dialogData["q_dt"]
      }
    }
  }
  get getControls() {
    return this.fieldForm.controls;
  }
  isControlHasError(controlName: string, validationType: string,): boolean {
    return this.appService.isControlHasError(this.fieldForm, controlName, validationType)
  }
  onBoxClick(item: FormElement) {
    this.formElementArr.map(i => i.selected = i.type == item.type ? true : false);
    this.selectedElement.type = item.type;
    this.selectedElement.title = item.name;
    this.isError = false;
    this.selectedElement.q_dt = ''
    this.selectedElement.desc = ''
  }
  onCancel() {
    this.dialogRef.close()
  }
  onStartCountClick(value: string) {
    if ((this.starCount >= 3) && (this.starCount <= 5)) {
      if (value == 'add' && (this.starCount < 5)) {
        this.starCount = this.starCount + 1;
      }
      if (value == 'sub' && (this.starCount > 3)) {
        this.starCount = this.starCount - 1;
      }
    }
    this.selectedElement.rt = this.starCount;
  }
  onAddItem() {
    let obj = {
      val: ""
    }
    this.selectOptionArr.push(obj)
  }
  onDeleteItem(id: number) {
    this.selectOptionArr[id].slideOut = true;
    setTimeout(() => {
      this.selectOptionArr.splice(id, 1);
    },300); // Match the animation duration
  }
  hasDuplicateValues(array) {
    const valuesSet = new Set();

    for (const item of array) {
      const value = item.val;
  
      if (valuesSet.has(value)) {
        return true; // Found a duplicate
      }
  
      valuesSet.add(value);
    }
  
    return false; // No duplicates fou
  }
  onSave() {
    this.errorMsg=""
    this.isError = false;
    this.selectedElement.isOptionErr = false;
    this.selectedElement.q_dt = this.selectOptionArr;
    if ((this.selectedElement.su_q == '' || this.selectedElement.su_q == null) && this.selectedElement.type!= 'description') {
      this.isError = true;
    }
    if ((this.selectedElement.desc == '' || this.selectedElement.desc == null) && this.selectedElement.type == 'description') {
      this.isError = true;
    }
    if ((this.selectedElement.type == 'dropdown')) {
      let isArrayEmpty = this.selectOptionArr.every(element => typeof element.value === 'string' && element.value.trim() === '')
      if (isArrayEmpty == true) {
        this.selectedElement.isOptionErr = true;
        this.isError = true;
        this.errorMsg="Please add options"
      }
      const anyValueEmpty = this.selectOptionArr.some(item => item.val === '');
      if(anyValueEmpty){
        this.selectedElement.isOptionErr = true;
        this.isError = true;
        this.errorMsg="No empty values allowed"
      }
      const hasDuplicate = this.hasDuplicateValues(this.selectOptionArr) 
    
      if(hasDuplicate){
        this.selectedElement.isOptionErr = true;
        this.isError = true;
        this.errorMsg="No duplicate values allowed"
      }
    }
    if ((this.selectedElement.type == 'numeric_range') ) {
      if(this.selectedElement.min == '' || this.selectedElement.min <0 ||  this.selectedElement.min  >this.selectedElement.max 
       || this.selectedElement.max == '' || this.selectedElement.max <0){
        this.isError=true;
      }
  
    }
    if (this.isError == false) {
      let dataObj:{}=this.selectedElement;
        delete dataObj["isOptionErr"]
        delete dataObj["title"]
      if(this.selectedElement.type!="rating"){
        delete dataObj["rt"]
      }
      if(this.selectedElement.type!="dropdown"){
        delete dataObj["q_dt"]
        // delete dataObj["i_m"]
      }
      // Always send data in q_dt in questions end
      if(this.selectedElement.type=='rating'){
        dataObj["q_dt"]=this.starCount;
      }
      if(this.selectedElement.type!="numeric_range"){
        delete dataObj["min"]
        delete dataObj["max"]
        // delete dataObj["i_m"]
      }
      this.dialogRef.close({ data: this.selectedElement })
    }
  }
}
